export default [
  { path: '', component: () => import('./pages/Dashboard.vue') },
  { path: 'iframe/:endpoint?', component: () => import('./pages/IFrame.vue') }
  // { path: 'domo', component: () => import('pages/Domo.vue') }
]
